import React, {useEffect} from "react";
import {useScreenConfig} from "./ScreenConfigContext";
import useScreenFloorDistance from "./rules/useScreenFloorDistance";

export default function SeatScreenLink()
{
    const { setScreenFloorDistance } = useScreenConfig();
    const dist = useScreenFloorDistance();

    useEffect(() => {
        setScreenFloorDistance(dist)

    }, [dist, setScreenFloorDistance]);

    return <></>;
}